import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  aboutComp: {
    backgroundColor: '#100e17',
    color: '#fff',
    padding: '30px 7%'
  },
  aboutTitle: {
    fontSize: '2.3em',
    fontWeight: 500,
  },
  shortNote: {
    marginTop: 10,
    lineHeight: 1.5,
    fontSize: '1.2em',
    fontWeight: 100,
  },
  skillWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
  },
  skillName: {
    fontSize: '1.2em',
    fontWeight: 100,
    padding: '4px 10px',
    border: "2px solid #0A5FFF",
    borderRadius: 5,
    '&:hover': {
      transform: 'scale(1.02)',
    },
  },
  svgIcon: {
    objectFit: 'contain',
    height: 350
  },
  DoTitle: {
    fontSize: '2em',
    textAlign: 'center',
    marginTop: '2.5em',
    marginBottom: 25,
  },
  coderImgWrap: {
    [theme.breakpoints.down('sm')]:{
      display: 'none'
  }
  }
}))

export { useStyles };